import { bindable } from 'aurelia';
import { ICustomElementController } from '@aurelia/runtime-html';

import { getAWSBucketEndpoint, websiteShortCode } from '../../../../environment';

import './ds-posts-cards.scss';

export class DsPostsCards {
    constructor() {
        this.baseAwsEndpoint = getAWSBucketEndpoint('blogs');
    }

    @bindable blogs;
    @bindable blogRoute;
    baseAwsEndpoint: string | undefined;
    public readonly $controller: ICustomElementController<this>;
    parent;
    shortCode: string = websiteShortCode();

    blogsChanged() {
        this.blogs?.forEach(blog => {
            blog.content = blog.content?.replace(/(<([^>]+)>)/gi, '');
        });
    }

    binding() {
        const scope = this.$controller.scope;
        this.parent = scope.parent?.bindingContext;
    }

    // Reference: Alternative to the parent Context approach. We spammed this in au1, review.
    async tagClickHandler(tag) {
        await this.parent.tagClickHandler({
            name: tag.target.textContent.replace(' ', '').trim(),
            slug: tag.target.textContent.trim().replace(' ', '-').toLowerCase(),
            activate: true
        });
    }

    get bannerImageByWebsite() {
        switch (this.shortCode) {
            case 'CG':
                return '/logo/logo-cg.svg';
            case 'CX':
                return '/logo/logo-cx.svg';
            case 'DS':
                return '/logo/ds-logo-dark.svg';
            case 'GT':
                return '/logo/gt-logo-dark.svg';
            default:
                return 'UNDEFINED';
        }
    }
}
